
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/nft/[...pid]",
      function () {
        return require("private-next-pages/items/nft/[...pid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/nft/[...pid]"])
      });
    }
  